import { useState } from 'react'
import type { Payable } from '@core/payments'
import { RuleForm } from './RuleForm'

/**
 * Everything about recurrence, on a payment card.
 *
 * Two things live here because they are the same thought at two moments: the
 * note when a bill is unlike its own history, and the offer to stop
 * photographing it every month. Both belong to the invoice in front of you.
 *
 * The offer is never a question the sender is asked (rule 20) — this screen
 * is the administrator's, and it appears only after the invoice already
 * exists, so nothing is blocked on answering it.
 */
export function RecurringChip({
  payable,
  userId,
  onCreated,
}: {
  payable: Payable
  userId: string
  onCreated: () => void
}) {
  const [form, setForm] = useState(false)

  return (
    <>
      {payable.notes && (
        <p className="w-full text-sm text-warn text-center py-1">{payable.notes}</p>
      )}

      {!payable.recurringRuleId && (
        <button onClick={() => setForm(true)} className="w-full py-2 text-sm text-muted">
          Komt dit elke maand terug?
        </button>
      )}

      {form && (
        <RuleForm
          spaceId={payable.spaceId}
          userId={userId}
          initial={{
            partyId: payable.partyId,
            description: payable.supplierName ?? payable.description,
            category: payable.category,
            amountCents: payable.amountCents,
            iban: payable.iban,
            paymentReference: payable.paymentReference,
            dueDate: payable.dueDate,
          }}
          onDone={() => {
            setForm(false)
            onCreated()
          }}
          onCancel={() => setForm(false)}
        />
      )}
    </>
  )
}
